module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_06@2x-8465c045d862f6a10f0682c4aa8542e6.jpg";